<template>
	<div class="w-100">
		<div class="bg-white cursor-pointer" @click="popUpTabelGold()">
			<div class="border">
				<div class="bg-green-light p-3">
					<div class="row no-gutters">
						<div class="col-7">
							<p class="mb-0 text-15 font-semibold">Karat</p>
						</div>
						<div class="col-5 text-right">
							<p class="mb-0 text-15 font-semibold">Harga</p>
						</div>
					</div>
				</div>
				<div class="rouded-bottom px-3 pt-3">
					<div class="row no-gutters mb-3" v-for="data in get_quality_unit" v-if="data.type == 'gold'">
						<div class="col-7">
							<p class="mb-0 text-14 font-medium">{{data.name}}</p>
						</div>
						<div class="col-5 text-right">
							<p class="mb-0 text-14 font-medium">Rp {{formatPrice(tableListPriceGold(data.murni))}} /g</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Desktop from '@/pages/HomePageDesktop';
  	import config from '@/config/index.js'
	import axios from 'axios'
	export default{
		components: {
			Desktop,
		},
		data(){
			return {
				loc_detail: [],
				transaction_type: '',
				is_pop_up: false,
				is_pop_up_type: false,
				is_pop_up_shop: false,
				is_pop_up_location: false,
				is_pop_up_location_gojek: false,
				is_po_pup_tabel_gold: false,
				phone_number: {
					sm: '',
					cod: '',
					shop: '',
					gojek: '',
				},
				is_learn_more: false,
				is_load: false,
				is_load_regencies: false,
				is_load_state: false,
				lat_lng_location: "",
				social_media: {},
        real_price: {
        	emas: '',
					harga_silver_500: '',
					harga_silver_925: ''
        },
        
        
        transaction_item: [],
        transaction_inquiry_id: null,
      	inquiry: {
			    location_name: '',
			    location_address: '',
			    google_map_url: '',
			    longitude: 0,
			    latitude: 0,
			    detail_transaction: [
		        {
		          item_type: '', 
	            weight: '', 
	            carat: '', 
	            murni: '', 
	            referensi: '', 
	            unit_id: ''
		        }
			    ],
			    new_customer: true,
			    customer_id: null,
			    trx_place_type: '',
			    province_id: '',
			    regency_id: ''
      	},
			  get_quality_unit: '',
			  murni: '',
			  provinces_id: '',
			  provinces: [],
			  provinces_selected: '',
			  regencies_id: '',
			  regencies: [], 
			  regencies_selected: '',
			  form_validate: {
			  	type_transaction: false,
			  	mitra_shop: false,
			  },
			  descending_unit: [],
			  center: { lat: 0, lng: 0 },
        markers: [],
        places: [],
			}
		},
		data() {
			return {
				loc_detail: [],
				transaction_type: '',
				is_pop_up: false,
				is_pop_up_type: false,
				is_pop_up_shop: false,
				is_pop_up_location: false,
				is_pop_up_location_gojek: false,
				is_po_pup_tabel_gold: false,
				phone_number: {
					sm: '',
					cod: '',
					shop: '',
					gojek: '',
				},
				is_learn_more: false,
				is_load: false,
				is_load_regencies: false,
				is_load_state: false,
				lat_lng_location: "",
				social_media: {},
        real_price: {
        	emas: '',
					harga_silver_500: '',
					harga_silver_925: ''
        },
        referensi_price: '',
				is_open: "gold",
				check_price: false,
				transaction_list: [
					
					{
						id: 'GOJEK',
						title: "Goemasin Aja (Kirim ke Goemas)",
						desc: "Mudah, Cepat, dan Perlindungan Penuh. Dapatkan Uang Langsung (Pelajari lebih lanjut pada FAQ)"
					},
					{
						id: 'COD',
						title: "Home Services",
						desc: "Gold Specialist kami akan mengunjungi dan membeli emas anda dengan harga yang telah disepakati"
					},
					{
						id: 'AT_SHOP',
						title: "Goemas Outlet",
						desc: "Datang dan kunjungi Outlet Goemas secara langsung. Dapatkan uang langsung. Jangan lupa membawa Emas anda"
					},
				],
				
				category: [
					{
						name: "Emas",
						type: "gold"
					},
					{
						name: "Silver",
						type: "silver"
					},
				],
				price: 0,
				form: {
					gram: 10,
					carat: 22,
					price: 1,
					quality: 22,
					title: '',
					murni: 905,
					unit_id: ''
				},
				check_murni: '',
				focus: {
					gram: false,
					karat: false,
					map_name: false,
					keterangan: false,
				},
				flickityOptions: {
          initialIndex: 0,
          autoPlay: 3000,
	        prevNextButtons: false,
	        pageDots: false,
	        adaptiveHeight: true,
	        cellAlign: "left",
	        draggable: true,
	        wrapAround: true,
        },
       
        transaction_item: [],
        transaction_inquiry_id: null,
      	inquiry: {
			    location_name: '',
			    location_address: '',
			    google_map_url: '',
			    longitude: 0,
			    latitude: 0,
			    detail_transaction: [
		        {
		          item_type: '', 
	            weight: '', 
	            carat: '', 
	            murni: '', 
	            referensi: '', 
	            unit_id: ''
		        }
			    ],
			    new_customer: true,
			    customer_id: null,
			    trx_place_type: '',
			    province_id: '',
			    regency_id: ''
      	},
			  get_quality_unit: '',
			  murni: '',
			  provinces_id: '',
			  provinces: [],
			  provinces_selected: '',
			  regencies_id: '',
			  regencies: [], 
			  regencies_selected: '',
			  form_validate: {
			  	type_transaction: false,
			  	mitra_shop: false,
			  },
			  descending_unit: [],
			  center: { lat: 0, lng: 0 },
        markers: [],
        places: [],
			}
		},
		computed: {
			megic_price(){
				return config.megic_price
			},
			murni_price(){
				return config.murni_price
			},
			isPrice(){
				let display = 0
				if (this.is_open == 'gold') {
					if (this.check_murni) {
						display = Math.round((this.real_price.emas/1000) * this.murni_price * this.form.carat * this.form.gram)
					}else{
						display = Math.round((this.form.murni/1000) * this.real_price.emas * this.form.gram)
					}
				}else{
					if (this.form.quality == '925') {
						display = Math.round(this.form.gram * this.real_price.harga_silver_925)
					} else {
						display = Math.round(this.form.gram * this.real_price.harga_silver_500)
					}
				}
				return display
			},
			carat_18(){
				return Math.ceil((this.real_price.emas/1000) * this.megic_price * 18 * 1)
			},
			carat_14(){
				return Math.ceil((this.real_price.emas/1000) * this.megic_price * 14 * 1)
			},
			carat_9(){
				return Math.ceil((this.real_price.emas/1000) * this.megic_price * 9 * 1)
			},
			quality_925(){
				return this.real_price.harga_silver_925 * 1
			},
			quality_500(){
				return this.real_price.harga_silver_500 * 1
			},
			real_price_silver_price(){
				let display = 0
				if (this.form.quality == '925') {
					display = this.real_price.harga_silver_925
				}else{
					display = this.real_price.harga_silver_500
				}
				return display
			},
			real_price_silver_quality(){
				let display = 0
				if (this.form.quality == '925') {
					display = "silver jenis kualitas 925 karat"
				}else{
					display = "silver jenis kualitas 500 karat"
				}
				return display
			},
			validation_type_transaction(){
				let display = false
				if (this.transaction_type == ''){
					display = true
				}else{
					display = false
				}
				return display
			},
			validation_mitra_shop(){
				let display = false
				if (this.provinces_selected == '' || this.regencies_selected == '' || this.provinces_selected == null || this.regencies_selected == null){
					display = true
				}else{
					display = false
				}
				return display
			},
			validation_location(){
				if (this.lat_lng_location == '') {
					return false
				}else{
					return true
				}
			}
		},
		mounted(){
		
			this.getApiPrice()
			this.getApiUnit()
			this.getApiProvinces()
			this.getApiSocialMedia()
			this.geolocate()
		},
		methods:{
			// ...mapGetters([
			// 	'getCart',
			// 	'getCartTotal'
			// ]),
			// ...mapMutations([
			// 	'setCart',
			// 	'setDeleteCart',
			// 	'setResetCart'
			// ]),
			hitGogleAnalytics(event){
      	this.$gtag.event(event, { method: 'Google' })
      },
			getYear(){
				return new Date().getFullYear()
			},
			goToApp() {
				window.location = `https://goemas.page.link/app`;
			},
			getApiPrice(){
				this.is_load = true
				let res = ''
				axios
		      .get(config.API+'/form-data/latest-rates')
		      .then(response => {
		      	res = response.data
		      	this.real_price.emas = res.gold_sell
		      	this.real_price.harga_silver_500 = res.silver_500_sell
		      	this.real_price.harga_silver_925 = res.silver_sell_925
						this.is_load = false
		      })
			},
			getApiUnit(){
				this.is_load = true
				axios
		      .get(config.API+'/form-data/unit-list')
		      .then(response => {
		      	this.get_quality_unit = response.data
		      	this.descending_unit = JSON.parse(JSON.stringify(this.get_quality_unit))
						this.is_load = false
						this.descendingUnit(this.descending_unit)
						this.form.carat = this.get_quality_unit[22].quality
						this.form.murni = this.get_quality_unit[22].murni
						this.form.unit_id = this.get_quality_unit[22].id
		      })
			},
			getApiProvinces(){
				this.is_load = true
				axios
		      .get(config.API+'/form-data/provinces')
		      .then(response => {
		      	this.provinces = response.data
						this.is_load = false
		      })
			},
			getApiRegencies(){
				this.is_load_regencies = true
				axios
		      .get(config.API+'/form-data/regencies?province_id='+this.provinces_id)
		      .then(response => {
		      	this.regencies = response.data
		      	this.is_load_regencies = false
		      })
			},
			getApiSocialMedia(){
				this.is_load = true
				let res = ''
				axios
					.get(config.API+'/general-setting-social-media')
					.then(response => {
						res = response.data
						this.social_media = res
						this.phone_number.sm = res.whatsapp_sm
						this.phone_number.cod = res.whatsapp_sm_cod
						this.phone_number.shop = res.whatsapp_sm_shop
						this.phone_number.gojek = res.whatsapp_sm_gojek
						this.is_load = false
					})
			},
			getGeolocation(lat, lng){
      	axios.get(config.API+'/get-location-from-coor?lat='+lat+'&long='+lng+'')
      	.then(response => {
      		if (lat == 0 && lng == 0) {
      			this.lat_lng_location = '-'
      		}else{
      			this.lat_lng_location = response.data.data.formatted_address
      		}
      	})
      },
			
			geolocate() {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.markers = [];
          this.markers.push({ position: this.center });
      		this.getGeolocation(this.center.lat, this.center.lng)
        });
      },
			postApiInquiry(type){
				this.is_load_state = true
				let res = ''
      	var fd = new FormData();
				fd.append('newItem', JSON.stringify(this.inquiry));
      	axios.post(config.API+'/unquiry',fd).then(response => {
      		if (response.data.success) {
	      		res = response.data.id
	      		this.transaction_inquiry_id = res
		      	window.location.href = this.list_product_whatsapp(type)
		      	this.setResetCart()
		      	this.hideBgPopUp()
		      	this.transaction_type = ''
						this.toggleMenu('check-price-id')
						this.is_load_state = false
		      }else{
						this.is_load_state = false
		      	console.log("Message: ", response.data.message)
		      }
      	})
			},
			tableListPriceGold(data){
				return Math.round((data/1000) * this.real_price.emas)
			},
			tableListPriceSilver(data){
				let display = 0
				if (data == '925') {
					display = Math.round(this.real_price.harga_silver_925)
				} else {
					display = Math.round(this.real_price.harga_silver_500)
				}
				return display
			},
			toggleLocation(step){
				if (step == '2') {
					this.is_pop_up = false
					this.is_pop_up_type = true
				}else if (step == '3' && this.transaction_type == 'COD') {
					this.is_pop_up_location = true
					this.is_pop_up = false
					this.is_pop_up_type = false
				}else if (step == '3' && this.transaction_type == 'AT_SHOP') {
					this.is_pop_up = false
					this.is_pop_up_type = false
					this.is_pop_up_shop = true
				}else if (step == '3' && this.transaction_type == 'GOJEK') {
					// let location = {
					// 	address: "",
				 //    keterangan: "",
				 //    lng: "",
				 //    lat: "",
					// }
					this.is_pop_up_location_gojek = true
					this.is_pop_up = false
					this.is_pop_up_type = false
				}
			},
			toggleTransactionType(id){
				this.transaction_type = id
			},
			hideBgPopUp(){
				this.is_pop_up = false
				this.is_pop_up_type = false
				this.is_pop_up_location = false
				this.is_pop_up_location_gojek = false
				this.is_pop_up_shop = false
				this.is_po_pup_tabel_gold = false
			},
			toggleProductCategory(data){
				window.location.href = data
			},
			toggleOpen(data){
				this.hitGogleAnalytics('Tab Kategory / Cek Harga Ke Kalkulator')
				this.is_open = data
				this.check_price = false
				this.form.gram = ''
				this.form.carat = ''
				this.form.price = ''
				this.form.title = ''
				this.form.quality = ''
			},
			toggleSelectCarat(data){
				this.form.quality = data.quality
				this.form.carat = data.carat
				this.form.murni = data.murni
				this.form.title = data.title
				this.form.unit_id = data.id
				this.toggleMenu('check-price')
			},
			toggleCheckPrice(){
				this.check_price = !this.check_price
			},
			toggleForm(type, id){
				if (type == 'focus') {
					this.focus[id] = true
				}else{
          this.focus[id] = false 
				}
			},
			formatPrice(value) {
        let val = (value/1)	
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    	},
    	toggleMenu(data){
    		
    	},
    	toggleLearnMore(){
    		this.is_learn_more = !this.is_learn_more
    	},
    	toggleEmpty(){
    		this.form.gram = ''
				this.form.carat = ''
				this.form.price = ''
				this.form.title = ''
				this.form.quality = ''
    	},
    	togglePopUp(){
    		this.toggleEmpty()
    		this.is_pop_up = !this.is_pop_up
    		this.toggleMenu('check-price')
    	},
    	toggleBack(id){
    		if (id == 'to-item') {
    			this.is_pop_up_type = false;
    			this.is_pop_up = true;
    		}else if (id == 'to-type') {
    			this.is_pop_up_type = true;
    			this.is_pop_up_shop = false
    			this.is_pop_up_location = false;
    		}
    	},
    	
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/HargaEmas.vue